import { useSyncExternalStore } from 'react';

// "The feature-list load has ended" (it succeeded, or it failed with no cached list). The list itself
// is `featureSupportAdminCheck` (supportedFeatures.js); that key is written only after a successful
// fetch. The Phase 2 gate waits on the key, so a failed fetch with no cache left the parity pages on
// their spinner for good (round-3 GATES F6). CloudRestApiAccessContext marks the end of its load here;
// the gate then closes (flag off, legacy page) instead of waiting for a list that never comes.
let settled = false;
const listeners = new Set();

export const isFeatureListSettled = () => settled;

export const markFeatureListSettled = (value = true) => {
  if (settled === value) return;
  settled = value;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useFeatureListSettled = () => useSyncExternalStore(subscribe, isFeatureListSettled, () => false);
